import React from "react";
import {
  AnchorLink,
  Button,
  Layout,
  Padding,
  Text,
} from "@kidslivesafe/sc-react";
import {
  useAppDispatch,
  useAppSelector,
  useHandlePageNavigate,
} from "../../../hooks/hooks";
import ProtectionShell from "./ProtectionShell";
import {
  fetchCustomerBrokersAsync,
  selectProtectionState,
  selectProtectionRequestStatus,
  setOptOutType,
  startOptOutProcessAsync,
} from "../../../features/profileProtection/profileProtectionSlice";
import RemovalOptions from "./RemovalOptions";
import { sendMemberEventAsync } from "../../../features/admin/adminSlice";

const StartRemovals: React.FC = () => {
  const dispatch = useAppDispatch();
  const handleNavigate = useHandlePageNavigate();
  const requestStatus = useAppSelector(selectProtectionRequestStatus);
  const { emailVerified } = useAppSelector(selectProtectionState);
  const hasSentStartRemovalsViewedEvent = React.useRef(false);
  const hasSentRemovalsStartedEvent = React.useRef(false);

  React.useEffect(() => {
    if (!emailVerified) {
      handleNavigate("/protection/verify");
    }
  }, [emailVerified, handleNavigate]);

  React.useEffect(() => {
    if (!hasSentStartRemovalsViewedEvent.current) {
      dispatch(
        sendMemberEventAsync({
          EventCategory: "Profile Protection",
          EventAction: "Start Removals Viewed",
        }),
      );
      hasSentStartRemovalsViewedEvent.current = true;
    }
  }, [dispatch]);

  const sendMemberEvent = () => {
    if (!hasSentRemovalsStartedEvent.current) {
      dispatch(
        sendMemberEventAsync({
          EventCategory: "Profile Protection",
          EventAction: "Removals Started",
        }),
      );
      hasSentRemovalsStartedEvent.current = true;
    }
  };

  const handleConfirm = async () => {
    if (!emailVerified) {
      handleNavigate("/protection/verify");
      return;
    }

    if (requestStatus === "loading") {
      return;
    }

    dispatch(setOptOutType("site"));
    await dispatch(startOptOutProcessAsync());
    await dispatch(fetchCustomerBrokersAsync());
    sendMemberEvent();
    handleNavigate("/protection/status");
  };

  return (
    <ProtectionShell
      title="Start Removals"
      subtitle="You're almost there. Review what happens next, then confirm to get started."
      stepLabel="Step 3 of 3"
    >
      <RemovalOptions />
      <Padding top="md">
        <Layout
          type="flex"
          flexProps={{ direction: "column", alignItems: "center", gap: "sm" }}
        >
          <Button
            buttonText={
              requestStatus === "loading"
                ? "Loading..."
                : "Confirm & Start Removals"
            }
            color="primary"
            fill="fill"
            handleClick={handleConfirm}
            disabled={requestStatus === "loading"}
            loading={requestStatus === "loading"}
          />
          <Text size="xs" color="dark-gray" textAlign="center">
            You can check progress anytime from your dashboard
          </Text>
          <AnchorLink
            role="button"
            handleClick={() => handleNavigate("/protection/verify")}
          >
            Back
          </AnchorLink>
        </Layout>
      </Padding>
    </ProtectionShell>
  );
};

export default StartRemovals;
